/**
 * サイト全体のメタデータ・OGP 共通定数。
 *
 * - 外部サービス（note / X / Slack / Facebook 等）でURL貼り付け時に
 *   サムネイル付きカードを表示させるための OGP / Twitter Card 用の共通値。
 * - ベースURLは moovy+ と同じ運用方針で本番ドメインをハードコードしている。
 *   ローカル開発時は OGP の確認自体が外部サービス経由のため成立しないので
 *   環境変数による切替は行わない（moovy+ 側 https://moovyplus.jp/ も同方針）。
 */

/** 本番サイトのベースURL（OGPの絶対パス解決に使用） */
export const SITE_URL = 'https://studio.moovy.jp'

/** サイト名（og:site_name 用） */
export const SITE_NAME = 'moovy studio'

/** サイト共通の説明文（og:description / description のデフォルト） */
export const SITE_DESCRIPTION = '動画マーケティングSaaS - moovy studio'

/** Twitter 公式アカウント（twitter:site / twitter:creator 用） */
export const TWITTER_HANDLE = '@moovyjp'

/** OGP デフォルト画像（個別画像が無いページや、共通カード用のフォールバック） */
export const DEFAULT_OGP_IMAGE = {
  url: '/images/moovystudio_ogp.png',
  width: 1200,
  height: 630,
  alt: 'moovy studio - 動画マーケティングSaaS',
} as const

/**
 * 公開動画詳細ページの正規URL。
 *
 * 各ページの `alternates.canonical` と sitemap の URL を必ず一致させるため、
 * 両者でこのヘルパーを共有する（個別に文字列を組むと canonical と sitemap が
 * ズレて SEO 事故になる）。末尾スラッシュ・クエリは付けない。
 */
export const getVideoCanonicalUrl = (companyId: string, videoId: string): string =>
  `${SITE_URL}/company/${companyId}/videos/${videoId}`

/** 公開プレイリスト詳細ページの正規URL。用途は {@link getVideoCanonicalUrl} と同じ。 */
export const getPlaylistCanonicalUrl = (companyId: string, scenarioId: string): string =>
  `${SITE_URL}/company/${companyId}/playlist/${scenarioId}`
